import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getPurchaseInvoices = async () => {
  const response = await axiosInstance.get('PurchaseInvoice/get-purchase-invoices');
  return response.data;
};

export const getPurchaseInvoiceById = async (id) => {
  const response = await axiosInstance.get(`PurchaseInvoice/get-purchase-invoice/${id}`);
  return response.data;
};

export const addPurchaseInvoice = async (purchaseInvoice) => {
  const response = await axiosInstance.post('PurchaseInvoice/add-purchase-invoice', purchaseInvoice);
  return response.data;
};

export const updatePurchaseInvoice = async (purchaseInvoice) => {
  const response = await axiosInstance.put('PurchaseInvoice/update-purchase-invoice', purchaseInvoice);
  return response.data;
};

export const deletePurchaseInvoice = async (id) => {
  await axiosInstance.delete(`PurchaseInvoice/delete-purchase-invoice/${id}`);
};

export const getPurchaseInvoicesBySupplier = async (supplierId) => {
  const response = await axiosInstance.get(`PurchaseInvoice/by-supplier/${supplierId}`);
  return response.data;
};